import Entity from '../../models/Entity';
import {
	PublicClientBasicInformation,
	PublicClientFamily,
	PublicClientInterests,
	PublicClientProfileSummary
} from '../../models/PublicClientModels';
import { setPublicClientGuidToLocalStorage } from '../localStorage';
import { get, post, put, httpDelete } from './PublicClientApiWrapper';

const basePath = 'public';

export const getPublicClientBasicInformation = async (signal?: AbortSignal): Promise<PublicClientBasicInformation> => {
	return get<PublicClientBasicInformation>(`${basePath}/BasicInformation`, signal);
};

export const createOrUpdatePublicClientBasicInformation = async (
	basicInfo: PublicClientBasicInformation,
	signal?: AbortSignal
): Promise<string> => {
	const response = await post<string>(`${basePath}/BasicInformation`, basicInfo, signal);

	// The only point of storing the clientGuid in localStorage
	setPublicClientGuidToLocalStorage(response);
	return response;
};

export const getClientFamilyMembers = async (signal?: AbortSignal): Promise<PublicClientFamily[]> => {
	return get<PublicClientFamily[]>(`${basePath}/family`, signal);
};

export const addOrUpdateClientFamilyMember = async (
	familyMember: PublicClientFamily,
	signal?: AbortSignal
): Promise<number> => {
	return post<number>(`${basePath}/family`, familyMember, signal);
};

export const deleteClientFamilyMember = async (familyMemberClientId: number, signal?: AbortSignal): Promise<void> => {
	return httpDelete<void>(`${basePath}/family/${familyMemberClientId}`, signal);
};

export const getClientEntities = async (signal?: AbortSignal): Promise<Entity[]> => {
	return get<Entity[]>(`${basePath}/entities`, signal);
};

export const addOrUpdateClientEntity = async (entity: Entity, signal?: AbortSignal): Promise<number> => {
	return post<number>(`${basePath}/entities`, entity, signal);
};

export const deleteClientEntity = async (entityId: number, signal?: AbortSignal): Promise<void> => {
	return httpDelete<void>(`${basePath}/entities/${entityId}`, signal);
};

export const getPublicClientInterests = async (signal?: AbortSignal): Promise<string> => {
	return get<string>(`${basePath}/Interests`, signal);
};

export const updatePublicClientInterests = async (
	clientInterests: PublicClientInterests,
	signal?: AbortSignal
): Promise<void> => {
	return put(`${basePath}/Interests`, clientInterests, signal);
};

export const getPublicClientProfileSummary = async (signal?: AbortSignal): Promise<PublicClientProfileSummary> => {
	return get<PublicClientProfileSummary>(`${basePath}/ProfileSummary`, signal);
};

export const completePublicClientProfiling = async (signal?: AbortSignal): Promise<void> => {
	return put<void>(`${basePath}/profilecompletion`, null, signal);
};
